import {
  MediaReplaceButton,
  MediaRemoveButton,
} from '@components/media-upload';
const {
  i18n: { __ },
  components: { SelectControl, TextControl, Button, TextareaControl },
  blockEditor: { MediaUpload, MediaUploadCheck },
} = wp;

const PopupSettings = (props) => {
  const { attributes, setAttributes } = props;
  const { popup } = attributes;

  return (
    <>
      <SelectControl
        label={__('Video Source', 'b3rg')}
        options={[
          { value: 'embedded', label: 'Embedded Code' },
          { value: 'url', label: 'URL' },
          { value: 'upload', label: 'Upload' },
        ]}
        value={popup.popupVideo}
        onChange={(newValue) => {
          setAttributes({
            popup: {
              ...popup,
              popupVideo: newValue,
            },
          });
        }}
      />

      {popup.popupVideo === 'embedded' && (
        <TextareaControl
          label={__('Custom Embed Code', 'b3rg')}
          help="Copy & Paste the full embed code here"
          value={popup.customVideoScript}
          onChange={(newValue) => {
            setAttributes({
              popup: {
                ...popup,
                customVideoScript: newValue,
              },
            });
          }}
        />
      )}
      {popup.popupVideo === 'upload' && (
        <MediaUploadCheck>
          <MediaUpload
            onSelect={(newValue) => {
              setAttributes({
                popup: {
                  ...popup,
                  popupVideoUploadURL: newValue.url,
                  popupVideoUploadName: newValue.filename,
                },
              });
            }}
            allowedTypes={['video']}
            render={({ open }) => (
              <div className="media-upload video-upload">
                {popup.popupVideoUploadURL && (
                  <>
                    <div className="video-file-name">
                      <p>{popup.popupVideoUploadName}</p>
                    </div>
                    <div className="upload-buttons-wrapper">
                      <MediaReplaceButton onClick={open} />
                      <MediaRemoveButton
                        onClick={() =>
                          setAttributes({
                            popup: {
                              ...popup,
                              popupVideoUploadURL: null,
                              popupVideoUploadName: null,
                            },
                          })
                        }
                      />
                    </div>
                  </>
                )}
                {!popup.popupVideoUploadURL && (
                  <Button className="media-button upload-button" onClick={open}>
                    {__('Upload Video', 'berg')}
                  </Button>
                )}
              </div>
            )}
          />
        </MediaUploadCheck>
      )}
      {popup.popupVideo === 'url' && (
        <TextControl
          label={__('Video URL', 'b3rg')}
          type="text"
          value={popup.popupVideoURL}
          onChange={(newValue) => {
            setAttributes({
              popup: {
                ...popup,
                popupVideoURL: newValue,
              },
            });
          }}
        />
      )}
    </>
  );
};

export default PopupSettings;
